import React, { useEffect, useMemo } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button, Form, Modal, Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { fetchInprogressAudios, fetchRefreshInProgress, resetPackRequestor, unlockPack } from "../../../redux/JobModule/InProgressPage/InProgressAction";
import { error } from "console";

interface UnlockModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function UnlockModal(props: UnlockModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [error, setError] = React.useState<string>("");
  const loading = useSelector((state: RootState) => state.InProgressAudiosState.unlockLoading);

  //Getting each pack Requestor
  const currentRecord = useSelector((state: RootState) => state.InProgressAudiosState.currentRecord);

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };
  useEffect(() => {
    return () => {
      form.resetFields();
      setError("");
    };
  }, [props.openState]);

  const UnlockModalContent = useMemo(() => {
    const onFinish = async (value: any) => {
      try {
        await dispatch(unlockPack({ idPack: currentRecord.packId })).unwrap();
        handleModalClose();
        await dispatch(fetchRefreshInProgress({}));
      } catch (error: any) {
        setError("An error occurred while unlocking the job. Please try again.");
      }
    };

    return (
      <Spin
        spinning={loading}
        className=" overflow-hidden">
        <div className="d-flex flex-column gap-4 w-100 modal-body-content">
          <h4> Job Info</h4>
          <p>
            This job is being edited by <b> {currentRecord.lockedUserEmail} </b>
          </p>
          {error && <div className="error justify-content-end align-self-end mb-2">{error}</div>}
          <div className="d-flex gap-3 justify-content-end">
            <Button
              className="button radius"
              type="primary"
              loading={loading}
              htmlType="submit"
              onClick={onFinish}>
              Unlock Job
            </Button>

            <Button
              className="cancelButton"
              htmlType="reset"
              loading={loading}
              // loading={uploadLoading}
              onClick={handleModalClose}>
              Cancel
            </Button>
          </div>
        </div>
      </Spin>
    );
  }, [form, loading, currentRecord, error]);

  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        width={400}
        onCancel={handleModalClose}
        open={props.openState}>
        {UnlockModalContent}
      </Modal>
    </div>
  );
}

export default UnlockModal;
